import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import AppLayout from './components/AppLayout';
import Login from './components/Login';
import RequireRole from './components/RequireRole';
import RequireAuth from './components/RequireAuth';
import ReportSheet from './pages/ReportSheet';
import Profile from './pages/Profile';
import Admins from './pages/admin/Admins';
import Insights from './pages/admin/Insights';
import MyApp from './pages/admin/MyApp';
import NurseDetail from './pages/admin/NurseDetail';
import Nurses from './pages/admin/Nurses';
import Overview from './pages/admin/Overview';
import ReportSheets from './pages/admin/ReportSheets';
import UnitDetail from './pages/admin/UnitDetail';
import Units from './pages/admin/Units';
import './App.css';

const admin = (page) => <RequireRole role="admin">{page}</RequireRole>;
const charge = (page) => <RequireRole role="charge">{page}</RequireRole>;

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<RequireAuth><AppLayout /></RequireAuth>}>
            {/* Both roles. The backend scopes charge nurses to their own unit. */}
            <Route index element={<Overview />} />
            <Route path="nurses" element={<Nurses />} />
            <Route path="nurses/:nurseId" element={<NurseDetail />} />
            <Route path="profile" element={<Profile />} />
            {/* Charge only: admins never see individual report sheets. */}
            <Route path="report-sheets" element={charge(<ReportSheets />)} />
            <Route path="reports/:reportId" element={charge(<ReportSheet />)} />
            <Route path="app" element={charge(<MyApp />)} />
            {/* Admin only. */}
            <Route path="insights" element={admin(<Insights />)} />
            <Route path="units" element={admin(<Units />)} />
            <Route path="units/:unitId" element={admin(<UnitDetail />)} />
            <Route path="admins" element={admin(<Admins />)} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
